// "Nuevos ángulos" (carrusel desde una imagen generada) — webhook n8n
// `generar_nuevos_angulos` migrado a atlas `/v1/generate/angles` (ADR-600).
// Flag ADENTRO del helper:
//   ON  → atlas con JWT (`user_id` NO viaja) + `modo_utilizado:
//         'nuevos_angulos'`. Respuesta SIEMPRE objeto
//         `{response:'success', imagenes_generadas_ids}`. Sin créditos = 402
//         tipado (n8n se colgaba) → GenerateAdError billing (isActionable:
//         los callers muestran el copy de saldo en su alert).
//   OFF → webhook n8n byte-idéntico (que a veces respondía ARRAY — el parse
//         tolerante vive acá, los callers reciben los ids listos).
// La espera puede ser de 2-3 min, igual que hoy.

import { GENERATE_AUTH_TOKEN, USE_ATLAS_BACKEND } from '../config';
import { atlasBackendFetch } from './atlasBackend';
import { GenerateAdError } from './generateAdRequest';

const GENERAR_NUEVOS_ANGULOS_URL =
  'https://ai-agency-dt7d.onrender.com/webhook/generar_nuevos_angulos';

// Mismo copy de saldo que las generaciones de imagen (generateAdRequest).
const BILLING_MESSAGE =
  'No te alcanzan los créditos para esta generación. Sumá créditos o actualizá tu plan para continuar.';

/** Devuelve los ids de la tanda (strings). Vacío = falló (alert genérico del caller). */
export async function postGenerateAngles(body: {
  user_id: string;
  image_id: string | number;
  cantidad_imagenes?: number;
}): Promise<string[]> {
  if (USE_ATLAS_BACKEND) {
    const { user_id: _ignored, ...atlasBody } = body;
    const res = await atlasBackendFetch('/v1/generate/angles', {
      ...atlasBody,
      modo_utilizado: 'nuevos_angulos',
    });
    if (res.status === 402) {
      throw new GenerateAdError('billing', BILLING_MESSAGE, 'billing');
    }
    const data = (await res.json().catch(() => null)) as {
      imagenes_generadas_ids?: Array<string | number>;
    } | null;
    const ids = data?.imagenes_generadas_ids;
    return Array.isArray(ids) ? ids.map(String) : [];
  }
  const res = await fetch(GENERAR_NUEVOS_ANGULOS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: GENERATE_AUTH_TOKEN,
    },
    body: JSON.stringify(body),
  });
  let data: any = null;
  try {
    data = await res.json();
  } catch {
    return [];
  }
  if (Array.isArray(data) && data[0]?.imagenes_generadas_ids) {
    return (data[0].imagenes_generadas_ids as Array<string | number>).map(String);
  }
  if (data?.imagenes_generadas_ids) {
    return (data.imagenes_generadas_ids as Array<string | number>).map(String);
  }
  return [];
}
